module.exports = __webpack_public_path__ + "img/baseline-search-24px.4facf638.svg";